// P1 Phase E — a revision's schedule PUBLICATION configuration: which
// publication level it publishes at, which schedules are included and which
// qualifications are printed. Persisted as JSON on the revision row
// (EstimateRevisions.SchedulePublicationJson, db/14; saved through
// sp_SaveRevisionSchedulePublication; copied to a new revision by
// sp_CreateRevision). Nothing about the schedules' CONTENT is stored — they
// stay generated views of canonical data; this is only the proposal's
// choice of what to publish. Absent / invalid JSON = the defaults below
// (proposal level, every publishable schedule, every qualification).
import { PUBLICATION_LEVEL_KEYS, schedulesForLevel } from "../config/designSchedules";

export const PUBLICATION_JSON_VERSION = 1;

export function defaultPublication(level = "proposal") {
  const lvl = PUBLICATION_LEVEL_KEYS.includes(level) ? level : "proposal";
  return { v: PUBLICATION_JSON_VERSION, level: lvl, schedules: Object.fromEntries(schedulesForLevel(lvl).map(s => [s.key, true])), qualifications: {} };
}

// Parse stored JSON (string or object) into a normalized configuration;
// anything unreadable falls back to the defaults so a bad row never breaks the view.
export function parsePublication(json, fallbackLevel = "proposal") {
  let raw = json;
  if (typeof json === "string") { try { raw = json.trim() ? JSON.parse(json) : null; } catch { raw = null; } }
  if (!raw || typeof raw !== "object") return defaultPublication(fallbackLevel);
  const level = PUBLICATION_LEVEL_KEYS.includes(raw.level) ? raw.level : fallbackLevel;
  const base = defaultPublication(level);
  const schedules = { ...base.schedules };
  for (const [k, v] of Object.entries(raw.schedules || {})) if (k in schedules) schedules[k] = v !== false;
  const qualifications = {};
  for (const [k, v] of Object.entries(raw.qualifications || {})) if (v === false) qualifications[k] = false;
  return { v: PUBLICATION_JSON_VERSION, level, schedules, qualifications };
}

export const isSchedulePublished = (pub, key) => pub?.schedules?.[key] !== false;
export const isQualificationPublished = (pub, key) => pub?.qualifications?.[key] !== false;

export function setSchedulePublished(pub, key, on) { return { ...pub, schedules: { ...pub.schedules, [key]: !!on } }; }
export function setQualificationPublished(pub, key, on) {
  const q = { ...pub.qualifications };
  if (on) delete q[key]; else q[key] = false;
  return { ...pub, qualifications: q };
}
export function setPublicationLevel(pub, level) {
  // Changing the level re-derives which schedules exist at it; explicit
  // exclusions for schedules that also exist at the new level are kept.
  const next = defaultPublication(level);
  for (const [k, v] of Object.entries(pub.schedules || {})) if (k in next.schedules) next.schedules[k] = v;
  return { ...next, qualifications: { ...pub.qualifications } };
}

export const serializePublication = (pub) => JSON.stringify(parsePublication(pub));
export const publicationPayload = (revisionId, pub) => ({ revision_id: revisionId, publication_json: serializePublication(pub) });
export const samePublication = (a, b) => serializePublication(a) === serializePublication(b);
